if (!customElements.get('collection-background-video')) {
  customElements.define('collection-background-video', class extends HTMLElement {
    connectedCallback() {
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.toggle = this.querySelector('[data-video-toggle]');
      this.onToggle = () => this.setPlaying(!this.playing);
      this.onMotion = () => this.setPlaying(!this.motion.matches);
      this.toggle?.addEventListener('click', this.onToggle);
      this.motion.addEventListener('change', this.onMotion);
      if (!this.motion.matches) this.setPlaying(true);
    }

    setPlaying(playing) {
      const template = this.querySelector('template');
      if (!template) return;
      if (!this.player && playing) {
        template.parentElement.append(template.content.cloneNode(true));
        this.player = template.parentElement.querySelector('video, iframe');
        if (this.player instanceof HTMLVideoElement) {
          this.player.muted = true;
        } else {
          this.player.addEventListener('load', () => this.command(this.playing));
        }
      }
      this.playing = playing;
      if (!this.player) return;
      this.command(playing);
      this.toggle.hidden = false;
      this.toggle.setAttribute('aria-pressed', String(!playing));
      this.toggle.querySelector('[data-video-pause]').hidden = !playing;
      this.toggle.querySelector('[data-video-play]').hidden = playing;
    }

    command(playing) {
      if (this.player instanceof HTMLVideoElement) {
        if (playing) this.player.play().catch(() => this.setPlaying(false));
        else this.player.pause();
      } else {
        this.player.contentWindow?.postMessage(JSON.stringify({
          event: 'command', func: playing ? 'playVideo' : 'pauseVideo', args: []
        }), 'https://www.youtube.com');
      }
    }

    disconnectedCallback() {
      if (this.player) this.command(false);
      this.toggle?.removeEventListener('click', this.onToggle);
      this.motion.removeEventListener('change', this.onMotion);
    }
  });
}
